import React from 'react'
import IconTooltip from './IconTooltip'

function CustomIconTooltip(props) {
  const { info, ...otherProps } = props

  const content = Array.isArray(info.content) ? (
    <div>
      <h6>{info.title}</h6>
      {info.content.map((item, index) => (
        <p key={index}>{item}</p>
      ))}
    </div>
  ) : (
    info.content
  )

  return <IconTooltip {...otherProps} tooltipShow={content} />
}

export default CustomIconTooltip
